/**
 * Constants for the routing and UI navigation.
 */

const basename = process.env.REACT_APP_BASEPATH

const sessionStorage = process.env.REACT_APP_SESSION_STORAGE

export { basename, sessionStorage }
